import { render, staticRenderFns } from "./pwd.vue?vue&type=template&id=50beb164"
import script from "./pwd.vue?vue&type=script&lang=js"
export * from "./pwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports